// extracted by mini-css-extract-plugin
export var container = "_92-0";
export var error = "_92-9";
export var label = "_92-5";
export var light = "_92-6";
export var md = "_92-3";
export var sm = "_92-2";
export var thin = "_92-8";
export var thinBold = "_92-7";
export var vertical = "_92-4";
export var xs = "_92-1";